import React, { useEffect } from 'react';
import * as Yup from 'yup';
import { Card, Grid } from '@material-ui/core';
import { Description as DescriptionIcon } from '@material-ui/icons';

import { FetchError } from '../../../common/api/api';
import CardTitle from '../../../common/card/CardTitle';
import CardContent from '../../../common/card/CardContent';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import TaskTypeEntitySelector from '../components/TaskTypeEntitySelector';
import { useUpdateTaskType } from '../TaskType.hooks';
import { TaskType } from '../TaskType.interface';

export interface TaskTypeDetailCardProps {
  taskType: TaskType;
  onChange?: (taskType: Partial<TaskType>) => void;
  onError?: (error: FetchError) => void;
}

const TaskTypeDetailCard: React.FC<TaskTypeDetailCardProps> = (
  props: TaskTypeDetailCardProps
) => {
  const { taskType, onChange, onError } = props;
  const [{ data, isLoading, error }, updateTaskType] = useUpdateTaskType();

  useEffect(() => {
    if (data) {
      onChange?.(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (error) {
      onError?.(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <Card>
      <CardTitle>
        <DescriptionIcon />
        Task Type Details
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          error={error}
          isSubmitting={isLoading}
          initialValues={{ ...taskType }}
          validationSchema={Yup.object({
            name: Yup.string().required('Required'),
            label: Yup.string().required('Required'),
            prefix: Yup.string().required('Required'),
            targetEntity: Yup.string().required('Required')
          })}
          onSubmit={(dto: Partial<TaskType>) => {
            // name is primary key
            dto = { ...dto, name: taskType.name };
            updateTaskType(dto);
          }}
        >
          {({ values, errors, setFieldValue, submitForm }) => (
            <InlineForm>
              <InlineTextField
                disabled
                name='name'
                label='Name'
                placeholder='Enter the Task Type name'
              />
              <InlineTextField
                name='label'
                label='Label'
                placeholder='Enter the Task Type label'
              />
              <InlineTextField
                name='prefix'
                label='Prefix'
                placeholder='Enter the Task Type prefix'
              />
              <Grid item xs={12}>
                <TaskTypeEntitySelector
                  disabled={isLoading}
                  value={values.targetEntity}
                  errorMessage={errors.targetEntity}
                  onChange={(entity: string | null) => {
                    setFieldValue('targetEntity', entity || undefined, true);
                    submitForm();
                  }}
                />
              </Grid>
            </InlineForm>
          )}
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default TaskTypeDetailCard;
